import React from "react";
import moment from "moment";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { RoleCardData } from "../data/mockRoles";

interface RoleCardProps {
  role: RoleCardData;
  onEdit: (role: RoleCardData) => void;
  onDelete: (role: RoleCardData) => void;
  onOpenRole: (role: RoleCardData) => void;
  readOnly?: boolean;
}

const RoleCard: React.FC<RoleCardProps> = ({
  role,
  onEdit,
  onDelete,
  onOpenRole,
  readOnly = false,
}) => {
  return (
    <article className="rp-role-card">
      <div
        className="rp-role-card__top-clickable"
        onClick={() => onOpenRole(role)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onOpenRole(role);
          }
        }}
        aria-label={`Open ${role.name} role details`}
      >
        <div className="rp-role-card__body">
          <div className="rp-role-card__icon-wrap" aria-hidden>
            <Iconography icon={role.cardIcon} size={IconographySizes.Medium} />
          </div>
          <div className="rp-role-card__copy">
            <h3 className="rp-role-card__title">{role.name}</h3>
            <p className="rp-role-card__description">{role.description}</p>
          </div>
          <div className={(role.status === 1 ? "rp-role-card__status-enable" : "rp-role-card__status-disable")}></div>
        </div>

        <div className="rp-role-card__meta">
          <span>
            <Iconography icon="userGroup" size={IconographySizes.Small} />
            {role.usersCount} users
          </span>
          <span>
            <Iconography icon="clock" size={IconographySizes.Small} />
            {moment(role.createdOn).format("D MMM YYYY")}
          </span>
        </div>
      </div>

      <div className="rp-role-card__footer">
        <span className="rp-role-card__badge">{role.roleType}</span>
        <div className="rp-role-card__actions">
          <button
            type="button"
            className="rp-icon-btn"
            onClick={() => onEdit(role)}
            aria-label={`Edit ${role.name}`}
            disabled={readOnly}
          >
            <Iconography icon="pen" size={IconographySizes.Small} />
          </button>
          {role.canDelete ? (
            <button
              type="button"
              className="rp-icon-btn"
              onClick={() => onDelete(role)}
              aria-label={`Delete ${role.name}`}
              disabled={readOnly}
            >
              <Iconography icon="trashCan" size={IconographySizes.Small} />
            </button>
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default RoleCard;
